import styled from 'styled-components'

const GradientBackground = styled.div`
  display: flex;
  flex-grow: 1;
  background-image: linear-gradient(
    180deg,
    ${props => props.theme.colors.background.main} 13%,
    ${props => props.theme.colors.background.page} 100%
  );
`

export default GradientBackground
